import { render } from "./App.vue?vue&type=template&id=faf93b94"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/bundle-builder/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "faf93b94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('faf93b94', __exports__)) {
    api.reload('faf93b94', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=faf93b94", () => {
    api.rerender('faf93b94', render)
  })

}


export default __exports__